import React from "react";

const OnboardAmbulance = () => {
  return <div>OnboardAmbulance</div>;
};

export default OnboardAmbulance;
